// src/components/ui/ServiceVisual.jsx
// A service's visual: an uploaded photo thumbnail when present (the meaningful,
// premium state), otherwise a clean neutral placeholder. Matches the industry
// standard (Setmore/Fresha) — no emoji, no guessed icons.
import { Image as ImageIcon } from "lucide-react";

export default function ServiceVisual({ service, size = "md", className = "" }) {
  const box = size === "sm" ? "w-10 h-10" : "w-12 h-12";

  if (service?.imageUrl) {
    return (
      <div className={`${box} rounded-xl overflow-hidden bg-surface-100 shrink-0 ${className}`}>
        <img
          src={service.imageUrl}
          alt=""
          className="w-full h-full object-cover"
          onError={(e) => { e.target.style.display = "none"; }}
        />
      </div>
    );
  }

  return (
    <div className={`${box} rounded-xl bg-surface-100 border border-surface-200 flex items-center justify-center shrink-0 ${className}`}>
      <ImageIcon size={size === "sm" ? 16 : 18} className="text-ink-300" />
    </div>
  );
}
